module.exports = __webpack_public_path__ + "static/media/double-left-arrows-symbol.2d2a656c.svg";